





































import { Component, PropSync, Vue } from "vue-property-decorator";
import { dispatchAddEntry } from "@/store/uniabc/actions";

@Component
export default class AddEntry extends Vue {
  @PropSync("recomputeEntr", { type: Number }) updateEntr!: number;
  private label = "";
  private dialog = false;

  private save() {
    dispatchAddEntry(this.$store, this.label);
    this.updateEntr++;
    this.dialog = false;
    this.$router.push(`/entry/${this.label}`);
  }
}
